import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { Chapel } from "../../types/chapel";

interface ChapelState {
    selectedChapel: Chapel | null;
}

const initialState: ChapelState  = {
    selectedChapel: null,
};

const chapelSlice = createSlice({
    name: 'chapel',
    initialState,
    reducers: {
        setSelectedChapel: (state, action: PayloadAction<Chapel | null>) => {
            state.selectedChapel = action.payload;
        },
        clearSelectedChapel: (state) => {
            state.selectedChapel = null;
        },
    },
});

export const { setSelectedChapel, clearSelectedChapel } = chapelSlice.actions;
export default chapelSlice.reducer;

export const selectCurrentChapel = (state: RootState) => state.chapel.selectedChapel;